module.exports = __webpack_public_path__ + "img/html.38c5fd71.svg";